<template lang="pug">
div
  h1 Contact Us
  p
    | For service related questions, we recommend you to contact us using livechat or Support Ticket.
  h2 Email
  p.email
    | For general questions, email us at 
    a qhptt90l@pandafan-tech.intercom-mail.com
  p.email-notice
    | Note: This email is for receiving messages only. Our replies will be sent from @pandafan-tech.intercom-mail.com, @1s.life, or @beexio.com.
  h2 Postal Address
  p
    | Beexio B.V.
    br
    | Prof. J. H. Bavincklaan 2
    br
    | 1183 AT, Amstelveen
    br
    | The Netherlands
  //- h2 Phone Number for Business Cooperation
  //- p
  //-   | For service related questions, use Email, livechat or Support Ticket.
  //- p
  //-   | (+31) 97010241866
  h2 More Information
  p PandaFan is a service provided by Beexio B.V. and its subsidiaries.
  p BTW/VAT NL862117720B01
  p KvK 81502648
</template>
